import React from 'react';
import classnames from 'classnames/bind';
import useWindowSize from '@rooks/use-window-size';

import RichText from '@components/rich-text';
import { WagtailImageBackground } from '@components/image';
import { withSnapPoint } from '@components/snapping-slider';
import { forTabletLandscape, calculateAngle } from '../../utils/responsive';
import css from './cover.module.scss';

const styles = classnames.bind(css);

const CoverSlide = ({ title, subtitle, orgName, logo, backgroundUrl, backgroundImage, slideRef }) => {
    const { innerWidth, innerHeight } = useWindowSize();
    // Desktop angle
    let angle = 7;
    if (forTabletLandscape(innerWidth)) {
        angle = -calculateAngle(0.3 * (Math.min(0.65 * innerWidth, 800) - 15), innerHeight);
    }

    return (
        <div ref={slideRef} className={styles('cover-slide')}>
            <div className={styles('cover-slide__content')}>
                <RichText tag="h4" className={styles('cover-slide__subtitle')}>
                    {subtitle}
                </RichText>
                <RichText tag="h1" className={styles('cover-slide__title')}>
                    {title}
                </RichText>
                <div
                    className={styles('cover-slide__pattern')}
                    style={{
                        transform: `rotate(${angle}deg)`,
                    }}
                />
                <div className={styles('cover-slide__logo-container')}>
                    <img alt={orgName} className={styles('cover-slide__logo')} src={logo} />
                </div>
            </div>

            <WagtailImageBackground
                className={styles('cover-slide__background')}
                backgroundImage={backgroundImage}
                backgroundUrl={backgroundUrl}
            />
        </div>
    );
};

export default withSnapPoint(CoverSlide);
